<template>
  <div class="edit-company-railbank-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-office-building"></i>Edit company by Railsbank</span>
        
      </div>

      <el-form
        ref="companyForm"
        :model="companyForm"
        :rules="companyFormRules"
        label-width="150px"
        size="small"
        
        :label-position="device === 'mobile' ? 'top' : 'right'"
      >
        <el-row :gutter="50">
          <el-col>
            <el-divider content-position="left">Company</el-divider>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" style="padding: 0">
              <el-form-item prop="company_name" label="Company Name">
                <el-input v-model="companyForm.company_name"></el-input>
              </el-form-item>

              <el-form-item prop="website" label="Website">
                <el-input
                  prefix-icon="el-icon-link"
                  v-model="companyForm.website"
                ></el-input>
              </el-form-item>

              <el-form-item prop="email_contact" label="Email Contact">
                <el-input
                  prefix-icon="el-icon-message"
                  v-model="companyForm.email_contact"
                ></el-input>
              </el-form-item>

              <el-form-item prop="phone_number" label="Phone Number">
                <el-input
                  prefix-icon="el-icon-phone"
                  v-model="companyForm.phone_number"
                ></el-input>
                <!-- <the-mask class="el-input__inner" :masked="true" v-model="companyForm.phone_number" :mask="['+44###########']" /> -->
              </el-form-item>

              <el-form-item label="Status">
                <el-select
                  v-model="companyForm.status"
                  placeholder="please select status"
                >
                  <el-option label="Active" value="active"></el-option>
                  <el-option label="Off" value="off"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-col>

          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-divider content-position="left">KYB Company</el-divider>
            <el-form-item prop="name" label="Company Name">
              <el-input v-model="companyForm.kyc.company.name"></el-input>
            </el-form-item>

            <el-form-item prop="tradingName" label="Trading Name">
              <el-input
                v-model="companyForm.kyc.company.tradingName"
              ></el-input>
            </el-form-item>

            <el-form-item prop="typeOfBusiness" label="Type Of Business">
              <el-input
                v-model="companyForm.kyc.company.typeOfBusiness"
              ></el-input>
            </el-form-item>

            <el-form-item prop="natureofbusiness" label="Nature of Business">
              <!-- <el-input v-model="companyForm.kyc.company.natureofbusiness"></el-input> -->
              <el-autocomplete
                class="inline-input"
                v-model="companyForm.kyc.company.natureofbusiness"
                :fetch-suggestions="querySearchNatureofbusiness"
              ></el-autocomplete>
            </el-form-item>

            <el-form-item prop="regulateFinancial" label="Regulate Financial">
              <el-switch
                v-model="companyForm.kyc.company.regulateFinancial"
              ></el-switch>
            </el-form-item>

            <el-form-item prop="registrationNumber" label="Registration Number">
              <el-input
                v-model="companyForm.kyc.company.registrationNumber"
              ></el-input>
            </el-form-item>

            <el-form-item prop="approvedate" label="Approve Date">
              <el-date-picker
                v-model="companyForm.kyc.company.approvedate"
                type="date"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>

            <el-form-item prop="telephone" label="Telephone">
              <el-input
                prefix-icon="el-icon-phone"
                v-model="companyForm.kyc.company.telephone"
              ></el-input>
            </el-form-item>

            <el-form-item prop="webSite" label="Website">
              <el-input
                prefix-icon="el-icon-link"
                v-model="companyForm.kyc.company.webSite"
              ></el-input>
            </el-form-item>

            <el-form-item prop="email" label="Email Contact">
              <el-input
                prefix-icon="el-icon-message"
                v-model="companyForm.kyc.company.email"
              ></el-input>
            </el-form-item>

            <el-form-item prop="addressnumber" label="Address number">
              <el-input
                v-model="companyForm.kyc.company.addressnumber"
              ></el-input>
            </el-form-item>

            <el-form-item prop="street" label="Street">
              <el-input v-model="companyForm.kyc.company.street"></el-input>
            </el-form-item>

            <el-form-item prop="city" label="City">
              <el-input v-model="companyForm.kyc.company.city"></el-input>
            </el-form-item>

            <el-form-item prop="zipcode" label="Zipcode">
              <el-input v-model="companyForm.kyc.company.zipcode"></el-input>
            </el-form-item>

            <el-form-item prop="refinement" label="Refinement">
              <el-input
                v-model="companyForm.kyc.company.refinement"
              ></el-input>
            </el-form-item>

            <el-form-item prop="region" label="Region">
              <el-input v-model="companyForm.kyc.company.region"></el-input>
            </el-form-item>

            <el-form-item prop="countrycode" label="Country code">
              <el-autocomplete
                class="inline-input"
                v-model="companyForm.kyc.company.countrycode"
                :fetch-suggestions="querySearchCountrycode"
                @select="selectCompanyCountrycode"
                :maxlength="2"
              >
                <template slot-scope="{ item }">
                  <div>{{ item.country_code }} - {{ item.country_name }}</div>
                </template></el-autocomplete
              >
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-divider content-position="left">KYB Director</el-divider>

            <el-form-item prop="name" label="Director Name">
              <el-input v-model="companyForm.kyc.director.name"></el-input>
            </el-form-item>

            <el-form-item prop="dateOfBirth" label="Date Of Birth">
              <el-date-picker
                v-model="companyForm.kyc.director.dateOfBirth"
                type="date"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>

            <el-form-item prop="position" label="Position">
              <el-input v-model="companyForm.kyc.director.position"></el-input>
            </el-form-item>

            <el-form-item prop="telephone" label="Telephone">
              <el-input
                prefix-icon="el-icon-phone"
                v-model="companyForm.kyc.director.telephone"
              ></el-input>
            </el-form-item>

            <el-form-item prop="email" label="Email">
              <el-input
                prefix-icon="el-icon-message"
                v-model="companyForm.kyc.director.email"
              ></el-input>
            </el-form-item>

            <el-form-item prop="nationality" label="Nationality">
              <!-- <el-input v-model="companyForm.kyc.director.nationality"></el-input> -->
              <el-autocomplete
                prefix-icon="el-icon-s-flag"
                class="inline-input"
                v-model="companyForm.kyc.director.nationality"
                :fetch-suggestions="querySearchNationality"
              ></el-autocomplete>
            </el-form-item>

            <el-form-item prop="identifyType" label="Identify Type">
              <!-- <el-input v-model="companyForm.kyc.director.identifyType"></el-input> -->
              <el-select v-model="companyForm.kyc.director.identifyType">
                <el-option label="Passport" value="passport"></el-option>
                <el-option
                  label="Driving Licence"
                  value="driving-licence"
                ></el-option>
                <el-option
                  label="Identity Card"
                  value="identity-card"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item prop="identifyNumber" label="Identify Number">
              <el-input
                v-model="companyForm.kyc.director.identifyNumber"
              ></el-input>
            </el-form-item>

            <el-form-item prop="identifyExpire" label="Identify Expire">
              <el-date-picker
                v-model="companyForm.kyc.director.identifyExpire"
                type="date"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>

            <el-form-item prop="addressnumber" label="Address number">
              <el-input
                v-model="companyForm.kyc.director.addressnumber"
              ></el-input>
            </el-form-item>

            <el-form-item prop="street" label="Street">
              <el-input v-model="companyForm.kyc.director.street"></el-input>
            </el-form-item>

            <el-form-item prop="city" label="City">
              <el-input v-model="companyForm.kyc.director.city"></el-input>
            </el-form-item>

            <el-form-item prop="zipcode" label="Zipcode">
              <el-input v-model="companyForm.kyc.director.zipcode"></el-input>
            </el-form-item>

            <el-form-item prop="refinement" label="Refinement">
              <el-input
                v-model="companyForm.kyc.director.refinement"
              ></el-input>
            </el-form-item>

            <el-form-item prop="region" label="Region">
              <el-input v-model="companyForm.kyc.director.region"></el-input>
            </el-form-item>

            <el-form-item prop="residentCountry" label="Resident Country">
              <el-autocomplete
                prefix-icon="el-icon-s-flag"
                class="inline-input"
                v-model="companyForm.kyc.director.residentCountry"
                :fetch-suggestions="querySearchResidentCountry"
                @select="selectDirectorResidentCountrycode"
                :maxlength="2"
              >
                <template slot-scope="{ item }">
                  <div>{{ item.country_code }} - {{ item.country_name }}</div>
                </template>
              </el-autocomplete>
            </el-form-item>

            <el-form-item prop="countrycode" label="Country code">
              <el-autocomplete
                class="inline-input"
                v-model="companyForm.kyc.director.countrycode"
                :fetch-suggestions="querySearchCountrycode"
                @select="selectDirectorCountrycode"
                :maxlength="2"
              >
                <template slot-scope="{ item }">
                  <div>{{ item.country_code }} - {{ item.country_name }}</div>
                </template></el-autocomplete
              >
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="footer text-center">
        <el-button type="primary" :loading="submiting" @click="submitCompany()"
          >Submit</el-button
        >
        <el-button @click="cancelForm">Cancel</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import { getUtility } from "@/api/customer";
import { updateCompany } from "@/api/company";
export default {
  props: {
    formData: Object
  },
  computed: {
    device() {
      return this.$store.state.app.device;
    },
  },
  data() {
    return {
      submiting: false,
      errMsg: "",
      utility: {},
      companyForm: this.formData,
      companyFormRules: {},
    };
  },
  methods: {
    getUtility() {
      getUtility().then(({ result, data }) => {
        if (result) {
          this.utility = data;
        }
      });
    },
    resetForm() {
      if (this.$refs.companyForm) this.$refs.companyForm.resetFields();
    },
    querySearchCountrycode(queryString, cb) {
      var data = this.utility.country;
      var results = queryString
        ? data.filter(this.createFilter(queryString, "country_code"))
        : data;

      cb(results);
    },
    querySearchResidentCountry(queryString, cb) {
      var data = this.utility.country;
      var results = queryString
        ? data.filter(this.createFilter(queryString, "country_code"))
        : data;

      cb(results);
    },
    querySearchNationality(queryString, cb) {
      var data = this.utility.country;
      var results = queryString
        ? data.filter(this.createFilter(queryString, "nationality"))
        : data;
      const lists = [];
      results.forEach((item) => {
        lists.push({ value: item.nationality });
      });
      cb(lists);
    },
    querySearchNatureofbusiness(queryString, cb) {
      var data = this.utility.natureofbusiness;
      var results = queryString
        ? data.filter(this.createFilter(queryString, "name"))
        : data;
      const lists = [];
      results.forEach((item) => {
        lists.push({ value: item.name });
      });
      cb(lists);
    },
    selectCompanyCountrycode(item) {
      this.companyForm.company_countrycode = item.country_code;
    },

    selectDirectorCountrycode(item) {
      this.companyForm.director_countrycode = item.country_code;
    },
    selectDirectorResidentCountrycode(item) {
      this.companyForm.director_residentCountry = item.country_code;
    },

    createFilter(queryString, key) {
      return (item) => {
        return item[key].toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    cancelForm() {
      if(this.$route.query.ref && this.$route.query.ref == 'info'){
        this.$router.push(`/company/info/${this.companyForm.uid}`);
      }else{
        this.$router.push('/company')
      }
      
    },
    updateCompany() {
      this.submiting = true;
      this.errMsg = "";
      this.companyForm['venderType'] = this.companyForm.kyc.venderType
      updateCompany(this.companyForm.uid, this.companyForm).then(
        (result, message) => {
          this.submiting = false;
          if (result) {
            this.$confirm('Update Company successfully', 'Successfully', {
            confirmButtonText: 'OK',
            showCancelButton: false,
            type: 'success',
          }).then(() => {
            this.cancelForm()
          });
          } else {
            this.errMsg = message;
          }
        }
      );
    },
    submitCompany() {
      this.$refs.companyForm.validate((valid) => {
        if (valid) {
          this.updateCompany();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
  created() {
    this.getUtility();
    this.resetForm();
    
  },
};
</script>

<style lang="scss">
.edit-company-railbank-container{
    .el-form-item--small.el-form-item {
    margin-bottom: 16px;
  }
  .item__label {
    line-height: 30px;
    font-weight: bold;
  }

  .el-form-item__label {
    font-size: 11px;
  }

  .el-divider__text {
    font-weight: bold;
    font-size: 14px;
    color: #424242;
  }

  .footer{
    border-top: 1px solid #ebeef5;
    padding-top: 20px;
    margin-top: 20px;
    margin-left: -20px;
    margin-right: -20px;
  }
}
</style>
